export default "__VITE_ASSET__DXG42Vm4__"